export const WEEKLY_PORTFOLIO_URL =
  "https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/dev_assets/weekly_portfolio_latest.json";

export const WEEKLY_CORE_ID = "weekly-core";
export const WEEKLY_TACTICAL_ID = "weekly-tactical";

export function coinKey(coin) {
  return String(coin ?? "")
    .trim()
    .replace(/^['"]+|['"]+$/g, "")
    .replace(/\/USDT$/i, "")
    .toUpperCase();
}

export function parseWatchlistCoins(listOfCoins) {
  if (Array.isArray(listOfCoins)) {
    return listOfCoins.map((coin) => String(coin).trim()).filter(Boolean);
  }
  if (typeof listOfCoins !== "string") return [];
  const trimmed = listOfCoins.trim();
  if (!trimmed) return [];
  try {
    const parsed = JSON.parse(trimmed.replace(/'/g, '"'));
    if (Array.isArray(parsed)) {
      return parsed.map((coin) => String(coin).trim()).filter(Boolean);
    }
  } catch {
    // Python-style lists that are not valid JSON fall through.
  }
  return trimmed
    .replace(/^\[|\]$/g, "")
    .split(",")
    .map((coin) => coin.trim().replace(/^['"]+|['"]+$/g, ""))
    .filter(Boolean);
}

export function sameCoin(left, right) {
  return coinKey(left) === coinKey(right);
}

export function normalizeWeeklyPortfolio(data) {
  const list = (value) =>
    [
      ...new Set(
        (Array.isArray(value) ? value : [])
          .map((coin) => coinKey(coin))
          .filter(Boolean),
      ),
    ];
  return {
    core: list(data?.core),
    tactical: list(data?.tactical),
  };
}

export function weeklyLabelForCoin(asset, weeklyPortfolio) {
  if ((weeklyPortfolio?.core || []).some((coin) => sameCoin(coin, asset))) {
    return "Core";
  }
  if (
    (weeklyPortfolio?.tactical || []).some((coin) => sameCoin(coin, asset))
  ) {
    return "Tactical";
  }
  return "";
}
